import React from 'react';
import { chunk } from 'lodash';

function USPSection({ uspData }: { uspData: any[] }) {
  return (
    <div className="usp-section flex max-w-full gap-4 overflow-scroll overscroll-contain overscroll-x-auto py-4 md:overflow-hidden md:p-0 lg:overflow-hidden lg:p-0">
      {uspData.map((chunk, index) => {
        const text = chunk.find((c: { id: string }) => c.id === 'text')?.content?.text;
        return (
          <div key={index} className="usp-item flex items-center space-x-6">
            {index !== 0 && (
              <div className="usp-icon inline-block rounded-full bg-neutral-80 p-1 text-center text-3xl leading-4" />
            )}
            <div className="usp-text inline-block whitespace-nowrap text-lg">{text}</div>
          </div>
        );
      })}
    </div>
  );
}

export default USPSection;
